import { useNavigate } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import { useDriverTabs } from '@/hooks/useDriverTabs';

/**
 * The tab bar for screens that live on their own route.
 *
 * The home screen holds the tabs in its own state, so a screen outside it goes
 * home and says which tab to open. Without this the inspections list is a room
 * with one door: a driver who opened it by mistake has nowhere to go.
 */
export function AppBottomNav({ activeTab }: { activeTab: string }) {
  const navigate = useNavigate();
  const { tabs } = useDriverTabs();

  return (
    <div className="responsive-container fixed bottom-0 left-1/2 z-30 -translate-x-1/2 border-t border-border bg-background pb-[env(safe-area-inset-bottom)]">
      <BottomNavigation
        activeTab={activeTab}
        tabs={tabs}
        // replace, not push. Moving between here and the home screen stacked
        // history entries, so the phone's back button walked a driver through
        // every tab they had touched.
        onTabChange={(tab) => navigate('/', { state: { tab }, replace: true })}
      />
    </div>
  );
}
